<template>
  <div id="app">
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
import {store} from './vuex/index.js';

export default {
  name: 'app',
  store
}
</script>
<style lang="scss">
@import '../node_modules/bootstrap/scss/bootstrap.scss';
</style>




// WEBPACK FOOTER //
// src/App.vue